<script lang="ts" setup>
import { MarketMakerAvatar } from '@forgd/ui-kit/blocks/avatars'
import { Button } from '@forgd/ui-kit/button'
import { Popover, PopoverContent, PopoverTrigger } from '@forgd/ui-kit/popover'
import { Separator } from '@forgd/ui-kit/separator'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'

const auth = useAuth()
const { liquidityMe } = storeToRefs(auth)
const isPopoverOpen = ref(false)
</script>

<template>
  <Popover v-model:open="isPopoverOpen">
    <PopoverTrigger as-child>
      <Button variant="outline" size="sm" class="py-2">
        <MarketMakerAvatar :src="liquidityMe?.marketMakerImage" size="xs" bordered />
        <div class="text-xs font-semibold max-w-37.5 truncate">
          {{ liquidityMe?.marketMakerName }}
        </div>
        <ChevronDownIcon class="size-4 shrink-0 text-primal transition" :class="isPopoverOpen ? 'rotate-180' : ''" aria-hidden="true" />
      </Button>
    </PopoverTrigger>
    <PopoverContent
      side="bottom"
      align="end"
      class="overflow-visible p-0"
    >
      <div class="p-4 w-70">
        <div class="text-gray-600 text-xs">
          Signed in as
        </div>
        <div v-if="auth.me" class="text-sm font-semibold text-primal">
          {{ auth.me.firstName }} {{ auth.me.lastName }}
        </div>
        <div v-if="auth.me" class="text-gray-600 text-xs">
          {{ auth.me.email }}
        </div>
      </div>
      <Separator />
      <div class="p-4">
        <div class="flex items-center gap-3">
          <MarketMakerAvatar :src="liquidityMe?.marketMakerImage" size="lg" bordered />
          <div class="flex flex-col">
            <div class="font-semibold text-sm text-primal">
              {{ liquidityMe?.marketMakerName }}
            </div>
            <div class="text-xs text-accent">
              Your Market Maker
            </div>
          </div>
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>
